<form class="forgot-password-container">
  <div class="icon-close" (click)="closeModal()">
    <i class="icon-X"></i>
  </div>
  @if (!isSent) {
    <h3 class="modal-title">{{ 'Forgot your password' | translate }}?</h3>
    <p class="description">
      {{ 'To reset your password, enter the email address registered with IAS Plus below' | translate }}
    </p>
    <app-input
      [title]="'Email address' | translate"
      [placeholder]="'Enter email address' | translate"
      [formControl]="email"
      [pattern]="EMAIL_INPUT_REGEX"
      [pastePattern]="PASTE_EMAIL_REGEX"
      [isSubmitRequired]="true"
      [isSubmitted]="isSubmitted"
    ></app-input>
    <div class="verify-btn">
      <app-button
        ariaLabel="Send reset instructions"
        [buttonStyleType]="ButtonTypes.PRIMARY_0"
        [disabled]="!email.value?.length"
        [buttonSize]="BUTTON_SIZE.FULL_SIZE"
        (clicked)="resetPassword()"
      >{{ 'Send reset instructions' | translate }}
      </app-button>
    </div>
    <app-info [infoText]="'Deloitte passwords cannot be reset through IAS Plus' | translate"></app-info>
  } @else {
    <div class="verification-img">
      <img src="assets/images/email-verification.svg" alt="Verification email">
    </div>
    <h2 class="done-title">{{ 'Done, instructions sent' | translate }}!</h2>
    <p class="description verification-description">
      {{ 'Check your email' | translate }} <span
      class="text--bold">{{ email.value }}</span> {{ 'and follow the instructions' |  translate }}.</p>
  }
</form>
